module.exports = __webpack_public_path__ + "img/04.7104b7c3.webp";